<template>
  <section id="top" class="top">
    <!-- <div style="position: absoulte"></div> -->

    <!-- logo icon -->
    <div class="logo">
      <img src="@/assets/img/home/logo.jpg" alt="">
    </div>

    <!-- art font -->
    <div class="art-font">结盟连锁，全球首创</div>

    <!-- top nav -->
    <el-menu class="nav"
             mode="horizontal"
             :router="true"
             :default-active="link">
      <el-menu-item index="home">首页</el-menu-item>
      <el-menu-item index="about">关于我们</el-menu-item>
      <el-menu-item index="cooperation">创始合作</el-menu-item>
      <el-menu-item index="contact">联系我们</el-menu-item>
    </el-menu>

    <!-- login & register -->
    <div class="login">
      <a target="_banket" href="http://www.eapor.com/">登录</a>
      /
      <a target="_banket" href="http://www.eapor.com/home/client/useapplication.jsp">注册</a>
    </div>

    <!-- contact phone -->
    <div class="contact">
      <p>客服加盟 021 - 57466066</p>
    </div>
  </section>
</template>

<script>
import { Menu, MenuItem } from 'element-ui'
export default {
  name: 'navbar',
  components: {
    Menu,
    MenuItem
  },
  data () {
    return {
      /** - 默认激活的 index */
      link: 'home'
    }
  },
  mounted () {
    /**
     * @description 获取当前页面需要激活的 index
     */
    this.link = window.location.href.slice(
      window.location.href.search('#') + 2
    )
  }
}
</script>

<style lang="scss">
.nav.el-menu--horizontal.el-menu {
  border-bottom: none;
}
.el-menu-item {
  margin: 0 10px;
  width: 100px;
  text-align: center;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 14px;
  color: #000;
}
</style>

<style lang="scss" scoped>
.top {
  width: 1200px;
  height: 85px;
  margin: 0 auto;
  font-size: 14px;

  display: grid;
  grid-template-columns: 1fr 1.5fr 5fr 1fr 1.5fr;

  .logo {
    align-self: center;
    justify-self: center;

    img {
      height: 66px;
    }
  }

  .art-font {
    align-self: center;
    justify-self: center;
    font-size: 20px;

    font-family: 楷体;
  }

  .nav {
    align-self: center;
    justify-self: center;
  }

  .login {
    align-self: center;
    justify-self: center;
    a:hover {
      color: #ebeef5;
    }
  }

  .contact {
    text-align: center;
    align-self: center;
    justify-self: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu_components/Navbar.vue